import { render, staticRenderFns } from "./ProductScanReturn.vue?vue&type=template&id=72309aab&scoped=true&"
import script from "./ProductScanReturn.vue?vue&type=script&lang=js&"
export * from "./ProductScanReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72309aab",
  null
  
)

export default component.exports